// extracted by mini-css-extract-plugin
export var scrFilter = "styles-module--scrFilter--1rUEb";
export var loading = "styles-module--loading--hgBUS";